import type { FC } from 'react';
import { useCasinoGameBanners, useLoadTournaments } from '@mwl/core-lib';
import { CasinoBanner } from '@/components/CasinoBanner/CasinoBanner';
import { TournamentCard } from '@/components/TournamentCard/TournamentCard';
import { Winners } from '@/components/Winners/Winners';
import { casinoGamePageObject, formatTournamentToTournamentCard } from '@/utils';
import styles from './SideSection.module.scss';
export const SideSection: FC = () => {
  const {
    tournaments
  } = useLoadTournaments();
  const firstEvent = tournaments[0];
  const {
    banners,
    isLoading
  } = useCasinoGameBanners({
    position: 'game_page'
  });
  return <div className={styles.root} data-sentry-component="SideSection" data-sentry-source-file="SideSection.tsx">
      <div className={styles.winners}>
        <Winners {...casinoGamePageObject.sideSection.winnersList.nodeProps} productType="casino" data-sentry-element="Winners" data-sentry-source-file="SideSection.tsx" />
      </div>
      {firstEvent && <TournamentCard className={styles.tournament} key={firstEvent.uuid} {...formatTournamentToTournamentCard(firstEvent)} />}
      {!isLoading && banners.map(banner => <CasinoBanner className={styles.banner} key={banner.id} {...banner} width="full" />)}
    </div>;
};